import { jsx as _jsx } from "react/jsx-runtime";
import { incaAccessor } from '@cancercentrum/inca';
import { ErrandDebugBanner } from './ErrandDebugBanner';
import { RegisterRecordDebugBanner } from './RegisterRecordDebugBanner';
export const DebugBanner = (props)=>{
    const inca = incaAccessor();
    if (process.env.NODE_ENV !== 'production' && !inca.form.useSimplifiedErrandType) {
        if (inca.errand) {
            return /*#__PURE__*/ _jsx("div", {
                className: "rcc-react-dev debug-banner errand mb-2",
                children: /*#__PURE__*/ _jsx(ErrandDebugBanner, {
                    ...props
                })
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "rcc-react-dev debug-banner registerrecord mb-2",
            children: /*#__PURE__*/ _jsx(RegisterRecordDebugBanner, {})
        });
    }
    return null;
};
